import { render, staticRenderFns } from "./amountDetail.vue?vue&type=template&id=014de704&scoped=true&"
import script from "./amountDetail.vue?vue&type=script&lang=js&"
export * from "./amountDetail.vue?vue&type=script&lang=js&"
import style0 from "./amountDetail.vue?vue&type=style&index=0&id=014de704&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014de704",
  null
  
)

export default component.exports